'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getFileDetail;

var _isImage = require('./isImage');

var _isImage2 = _interopRequireDefault(_isImage);

var _toast = require('../../toast');

var _toast2 = _interopRequireDefault(_toast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * get file detail
 *
 * @param file
 * @returns {{fileName, fileSize, fileType: string, isPic: boolean}}
 */
function getFileDetail(file) {
  var fileSize = file.size;

  var fileName = file.name;

  var fileType = file.type || fileName.substr(fileName.lastIndexOf('.') + 1);

  // wechat save image bug
  if (!/.*\/.*/.test(fileType)) {
    _toast2.default.warning('图片格式有误，请重新拍照上传');
  }

  var isPic = (0, _isImage2.default)(fileType);

  return {
    fileName: fileName,
    fileSize: fileSize,
    fileType: fileType,
    isPic: isPic
  };
}